import React, { useState } from 'react';
import Data from '../constants.json';
import Team from './teams';
import Member from './members';
const { userManagementNavItem } = { ...Data };

const UserManagement = () => {
  const [activeTab, setActiveTab] = useState(1);

  const handleClickSelect = (id) => {
    setActiveTab(id);
  }

  return (
    <>
      <div className='containerSubNavCss'>
        {userManagementNavItem.map(({ name, id }) => {
          return (
            <a key={id} data-testid={`nav-${name}`} onClick={() => handleClickSelect(id)} className= {activeTab === id ? 'active' : ''} >{`${name}`}</a>
          );
        })}
      </div>
      <div className='componentContainer'>
        {
          activeTab === 1 ?
          <Member/> : <Team/>
        }
      </div>
    </>
  );
};
export default UserManagement;

